import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import slugify from "react-slugify";

const JobPostingsDetails = () => {
  // const [phone, setPhone] = useState('');

  // const handleChange = (e) => {
  //     const input = e.target.value.replace(/\D/g, ''); // rəqəmlərdən başqa hamını silir
  //     const formatted = formatPhone(input);
  //     setPhone(formatted);
  // };

  // const formatPhone = (value) => {
  //     const part1 = value.slice(0, 2);
  //     const part2 = value.slice(2, 5);
  //     const part3 = value.slice(5, 7);
  //     const part4 = value.slice(7, 9);

  //     let result = part1;
  //     if (part2) result += '-' + part2;
  //     if (part3) result += '-' + part3;
  //     if (part4) result += '-' + part4;

  //     return result;
  // };
  const { jobId } = useParams();
  const [showEmail, setShowEmail] = useState(false);
  const [showPhone, setShowPhone] = useState(false);

  const [jwtToken] = useState(localStorage.getItem("jwt") || "");
  const [cv, setCv] = useState([]);
  useEffect(() => {
    axios
      .get("https://www.turanozbahceci.com/api/list-cv.php")
      .then((res) => {
        setCv(res.data.cvList);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const findData =
    jobId &&
    cv.find(
      (item) => slugify(`${item.id}-${item.ad}-${item.soyad}-${item.vezife}`) === jobId
    );

  
  const formatAndMaskPhone = (number) => {
    const cleaned = number.replace(/\s+/g, "");
    const part = cleaned.slice(4);
    const formatted = part.replace(
      /(\d{2})(\d{3})(\d{2})(\d{2})/,
      "$1-$2-$3-$4"
    );
    return formatted.replace(/(\d{2}-\d{3})-\d{2}-\d{2}/, "$1-XX-XX");
  };

  function maskEmail(email) {
    const [local, domain] = email.split("@"); // local = admintest, domain = gmail.com

    const visible = local.slice(0, 4); // ilk 3 hərfi alırıq
    const maskedPart = "x".repeat(local.length - 3); // qalanları x edir

    return `${visible}${maskedPart}@${domain}`;
  }

 console.log(findData);
 const findRejim =
 findData && findData.rejim == "0"
   ? "Tam-ştat"
   : findData && findData.rejim == "1"
   ? "Yarım-ştat"
   : findData && findData.rejim == "2"
   ? "Frilans"
   : findData && findData.rejim == "3"
   ? "Təcrübəçi"
   : findData && findData.rejim == "4"
   ? "Uzaqdan"
   : findData && findData.rejim == "5"
   ? "Müvəqqəti iş"
   : "";

   const findEducation =
   findData && findData.tehsil == "0"
     ? "Ali"
     : findData && findData.tehsil == "1"
     ? "Natamam"
     : findData && findData.tehsil == "2"
     ? "Orta"
     : "";

     const findWorkExperience =
     findData && findData.isht == "0"
       ? "1 ildən az"
       : findData && findData.isht == "1"
       ? "1 ildən 3 ilə qədər"
       : findData && findData.isht == "2"
       ? "3 ildən 5 ilə qədər"
       : findData && findData.isht == "3"
       ? "5 ildən yüksək"
       : "";
  return (
    <>
      {findData && (
        <section className="cvDetails py-5" style={{ background: "#FAFAFA" }}>
          <div className="container-fluid">
            <p>
              Ana səhifə / İnsan Resusrları Portalı / CV BANK /{" "}
              {findData.vezife}
            </p>
            <div className="row g-4">
              <div className="col-lg-8 col-md-8 col-sm-12 col-12 ">
                <h4 className="my-4">
                  {findData.ad} {findData.soyad}
                </h4>
                <div className="details">
                  <div className="row p-5 ">
                    <div className="col-12">
                      <h4 className="mb-4">Əsas məlumatlar</h4>
                      <div className="detailsBox">
                        <div className="d-flex align-items-center">
                          <i class="fa-solid fa-calendar-days"></i>
                          <p className="ms-2">Doğum tarixi: 18.02.1999</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 py-5">
                      <h4 className="mb-4">Karyera hədəfi</h4>
                      <div className="detailsBox">
                        <div className="d-flex align-items-center">
                          <i class="fa-solid fa-briefcase"></i>
                          <p className="ms-2">{findData.vezife}</p>
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i class="fa-solid fa-money-bill"></i>
                          <p className="ms-2">{findData.emekhaqqi} ₼</p>
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i class="fa-solid  fa-calendar-days"></i>
                          <p className="ms-2">{findRejim}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <h4 className="mb-4">İş təcrübəsi</h4>
                      <div className="detailsBox">
                        <div className="d-flex align-items-center">
                          <h5>Baku Electronics</h5>
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i class="fa-solid fa-briefcase"></i>
                          <p className="ms-2">{findData.vezife} Intern</p>
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i class="fa-solid  fa-calendar-days"></i>
                          <p className="ms-2">{findWorkExperience}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <h4 className="mb-4">Təhsil</h4>
                      <div className="detailsBox">
                        <div className="d-flex align-items-center">
                          {/* <h5>Azərbaycan Dövlət İqtisad Universiteti</h5> */}
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i class="fa-solid fa-briefcase"></i>
                          <p className="ms-2">{findEducation}</p>
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i class="fa-solid  fa-calendar-days"></i>
                          <p className="ms-2">2017-2021</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <h4 className="mb-4">Dil bilikləri</h4>
                      <div className="detailsBox">
                        <div className="d-flex align-items-center">
                          <h5>{findData.dil}</h5>
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i className="fa-solid fa-globe"></i>
                          <p className="ms-2">Əla</p>
                        </div>
                      </div>
                      {/* <div className="detailsBox my-4">
                        <div className="d-flex align-items-center">
                          <h5>İngilis</h5>
                        </div>
                        <div className="d-flex align-items-center my-3">
                          <i className="fa-solid fa-globe"></i>
                          <p className="ms-2">Orta</p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12 ">
                <h4 className="my-4" style={{ opacity: "0" }}>
                  .
                </h4>
                <div className="details">
                  <div
                    className="profile"
                    style={{ position: "sticky", top: "0" }}
                  >
                    <div className="d-flex justify-content-center align-items-center flex-column">
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/046/409/821/non_2x/avatar-profile-icon-in-flat-style-male-user-profile-illustration-on-isolated-background-man-profile-sign-business-concept-vector.jpg"
                        alt=""
                        className="img-fluid"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                      <div className="profileDesc text-center">
                        <h6>
                          {findData.ad} {findData.soyad} ({findData.yash})
                        </h6>
                        <p style={{ marginBottom: "0" }} className="my-2">
                          {findData.vezife}
                        </p>
                        <p>
                          <i
                            className="fa-solid fa-location-dot mx-2"
                            style={{ color: "#20AD96" }}
                          ></i>
                          {findData.sheher}
                        </p>
                        <span style={{ fontSize: "small" }}>
                          Yerləşdirildi : 17.03.2025
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="details my-3">
                  <div
                    className="profile p-3"
                    style={{ position: "sticky", top: "0" }}
                  >
                    <div>
                      <h5>Əmək haqqı gözləntisi</h5>
                      <div className="d-flex align-items-center my-3">
                        <i class="fa-solid fa-money-bill"></i>
                        <p className="ms-2">{findData.emekhaqqi} ₼</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="details my-3">
                  <div
                    className="profile p-3"
                    style={{ position: "sticky", top: "0" }}
                  >
                    <div>
                      <h5>Əlaqə məlumatları</h5>
                      <div className="d-flex justify-content-between align-items-center my-3">
                        <div className="d-flex align-items-center">
                          <i class="fa-solid fa-phone"></i>
                          <p className="ms-2">
                            {" "}
                            {showPhone
                              ? findData.telefon
                              : formatAndMaskPhone(findData.telefon)}
                          </p>
                        </div>
                        <div
                          className="openEmail"
                          onClick={() => setShowPhone(!showPhone)}
                        >
                          <i
                            className={`fa-solid fa-${
                              showPhone ? "eye-slash" : "eye"
                            } `}
                          ></i>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center my-3">
                        <div className="d-flex align-items-center">
                          <i class="fa-solid fa-envelope"></i>
                          <p className="ms-2">
                            {showEmail
                              ? findData.email
                              : maskEmail(findData.email)}
                          </p>
                        </div>
                        <div
                          className="openEmail"
                          onClick={() => setShowEmail(!showEmail)}
                        >
                          <i
                            className={`fa-solid fa-${
                              showEmail ? "eye-slash" : "eye"
                            } `}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="details">
                  <div className="d-flex justify-content-center align-items-center">
                    <button className="w-100 m-3 btn btn-primary fs-6"> <i className="fa-solid fa-download mx-2"></i> CV-ni yüklə</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default JobPostingsDetails;
